module.exports = __webpack_public_path__ + "static/media/grid.ceff07a4.svg";